import { render } from "./SpotifySong.vue?vue&type=template&id=1487efed&scoped=true"
import script from "./SpotifySong.vue?vue&type=script&lang=js"
export * from "./SpotifySong.vue?vue&type=script&lang=js"

import "./SpotifySong.vue?vue&type=style&index=0&id=1487efed&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1487efed"]])

export default __exports__